import { Component, OnInit, Inject } from '@angular/core';
import { Control } from '../../models/model-year';
import { AdminService } from '../../../admin/admin.service';
import { TCCPLocalStorageService } from '../../services/tccp-local-storage.service';
import { environment } from '../../../../environments/environment';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-preview-feature-flow-dialog',
  templateUrl: './preview-feature-flow-dialog.component.html',
  styleUrls: ['./preview-feature-flow-dialog.component.scss']
})

export class PreviewFeatureFlowDialogComponent implements OnInit {

  public controls: Control[];
  public theme: string;

  constructor(
    private adminService: AdminService, private storageService: TCCPLocalStorageService,
    public dialogRef: MatDialogRef<PreviewFeatureFlowDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {

  }

  ngOnInit() {
    this.theme = this.adminService.selectedApplication;
    this.controls = this.data;
    this.storageService.setVehicleFeatures(this.controls);
  }

  close(): void {
    this.controls = [];
    this.storageService.setVehicleFeatures(this.controls);
    environment.applicationName = 'admin';
    this.dialogRef.close();
  }

}

